/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import { CheckboxState } from 'ui/designSystem/types'

export const getCheckboxState = (
  isChecked: boolean,
  indeterminate?: boolean,
  hasError?: boolean,
  disabled?: boolean
): CheckboxState[] => {
  const states: CheckboxState[] = []

  if (disabled) states.push('disabled')
  if (hasError) states.push('error')
  if (indeterminate) states.push('indeterminate')
  else if (isChecked) states.push('checked')
  if (states.length === 0) states.push('default')
  return states
}
